export function showFormField(isEditable: boolean, value: unknown) {
  if (isEditable) {
    return true;
  }
  if (Array.isArray(value) ? value.length : !!value) {
    return true;
  }
  return false;
}
